import React from 'react';
import { Link } from 'react-router';
import { useTranslation } from '../contexts/LanguageContext';

export const NotFoundPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="not-found-page">
      <div className="not-found-content">
        <h1>404</h1>
        <h2>Game Not Found</h2>
        <p>The game you're looking for doesn't exist or has expired.</p>
        <Link to="/" className="back-home-button">
          {t.backToMenu}
        </Link>
      </div>
    </div>
  );
};
